import React, {useState} from 'react';
import {Card} from 'react-bootstrap';
import * as unicodeEmoji from 'unicode-emoji';

function EmojiTable({ showEmoji, onAddEmojiOrSpace }) {
  const emojis = unicodeEmoji.getEmojisGroupedBy("category");
  const [currentEmoji, setCurrentEmoji] = useState("face-emotion");
  const [navigation, setNavigation] = useState(
    {
      faceEmotion: "active-icon",
      objects: "",
      flags: "",
      foodDrink: "",
      animalsNature: "",
      activitiesEvents: "",
      personPeople: "",
      symbols: "",
      travelPlaces: ""
    });

  const handleSwitchListEmoji = (emojiCategory) => {
    let nav = navigation;

    nav.faceEmotion = "";
    nav.objects = "";
    nav.flags = "";
    nav.foodDrink = "";
    nav.animalsNature = "";
    nav.personPeople = "";
    nav.activitiesEvents = "";
    nav.symbols = "";
    nav.travelPlaces = "";

    switch (emojiCategory) {
      case "face-emotion": nav.faceEmotion = "active-icon";
        break;
      case "objects": nav.objects = "active-icon";
        break;
      case "flags": nav.flags = "active-icon";
        break;
      case "food-drink": nav.foodDrink = "active-icon";
        break;
      case "animals-nature": nav.animalsNature = "active-icon";
        break;
      case "person-people": nav.personPeople = "active-icon";
        break;
      case "activities-events": nav.activitiesEvents = "active-icon";
        break;
      case "symbols": nav.symbols = "active-icon";
        break;
      case "travel-places": nav.travelPlaces = "active-icon";
        break;
      default: // nothing here
        break;
    }

    setNavigation(nav);
    setCurrentEmoji(emojiCategory);
  }

  const listEmoji = (emojis) => {
    let listEmoji;

    listEmoji = emojis.map(emoji => {
      if (emoji.version !== "13.0") {
        return <span className="emoji-item" onClick={() => onAddEmojiOrSpace(emoji.emoji)}>{emoji.emoji}</span>;
      }

      return null;
    });

    return listEmoji;
  }

  return (
    <Card className={`emoji-table w-100 ${showEmoji}`}>
      <Card.Header className="emoji-table-header">
        <i className={`bi bi-emoji-smile ${navigation.faceEmotion}`} onClick={() => handleSwitchListEmoji("face-emotion")} ></i>
        <i className={`bi bi-person ${navigation.personPeople}`} onClick={() => handleSwitchListEmoji("person-people")} ></i>
        <i className={`bi bi-flower1 ${navigation.animalsNature}`} onClick={() => handleSwitchListEmoji("animals-nature")} ></i>
        <i className={`bi bi-cup-straw ${navigation.foodDrink}`} onClick={() => handleSwitchListEmoji("food-drink")} ></i>
        <i className={`bi bi-award ${navigation.activitiesEvents}`} onClick={() => handleSwitchListEmoji("activities-events")} ></i>
        <i className={`bi bi-truck ${navigation.travelPlaces}`} onClick={() => handleSwitchListEmoji("travel-places")} ></i>
        <i className={`bi bi-megaphone ${navigation.objects}`} onClick={() => handleSwitchListEmoji("objects")} ></i>
        <i className={`bi bi-alarm ${navigation.symbols}`} onClick={() => handleSwitchListEmoji("symbols")} ></i>
        <i className={`bi bi-flag ${navigation.flags}`} onClick={() => handleSwitchListEmoji("flags")} ></i>
      </Card.Header>
      <Card.Body className="emoji-table-body">
        {
          listEmoji(emojis[currentEmoji])
        }
      </Card.Body>
      <Card.Footer className="emoji-table-footer">
        <div className="emoji-table-footer--space" onClick={() => onAddEmojiOrSpace(" ")}>
          Space
        </div>
        <div className="emoji-table-footer--clear">Clear</div>
      </Card.Footer>
    </Card>
  )
}

export default EmojiTable;
